import type { EmojiProvider } from '@atlaskit/emoji';
import { EmojiResource } from '@atlaskit/emoji';
import memoizeOne from 'util/memoize-one';
import { reportError } from 'util/sentry';

export const getEmojiProvider = memoizeOne(
    (isEmojiEnabled: boolean, fabricEmojiUrl?: string): Promise<EmojiProvider> | undefined => {
        if (isEmojiEnabled && fabricEmojiUrl) {
            const emojiResource = new EmojiResource({
                providers: [{ url: `${fabricEmojiUrl}/emoji/standard` }, { url: `${fabricEmojiUrl}/emoji/atlassian` }],
                allowUpload: false,
            });

            return emojiResource
                .fetchEmojiProvider()
                .then(() => Promise.resolve(emojiResource))
                .catch((e) => {
                    reportError(e);
                    return Promise.reject(e);
                });
        }
        return undefined;
    }
);
